import { ButtonContainer } from "../../generic-sprites/Buttons"

export enum EveryCigBodyPart {
    BRAIN = "Brain",
    EYE = "Eyes",
    HEART = "Heart",
    LUNGS = "Lungs"
}

export enum EveryCigSpriteType {
    WARNING_SCREEN,
    BODY_PART_BUTTONS,
    VOTE_SCREEN
}

export interface EveryCigMovieStore {
    parts: Array<EveryCigBodyPart>
    selected?: EveryCigBodyPart
    voteAudio: boolean
    viewVotesAudio: boolean
}

export interface EveryCigSprite {
    destroy?: () => void
    sprite?: Phaser.Sprite
    fadeIn?: () => void
    fadeOut?: () => void
}

export interface EveryCigSpriteConfig {
    x?: number,
    y?: number,
    group?: Phaser.Group
    button?: ButtonContainer
}